module.exports = __webpack_public_path__ + "static/media/Nota Rutina Detox.1a745869.webp";